export const isCapacitor = () => window?.Capacitor?.isNativePlatform?.() ?? false;

export const isAndroid = () => isCapacitor() && window.Capacitor.getPlatform() === 'android';

export const isIOS = () => isCapacitor() && window.Capacitor.getPlatform() === 'ios';

export const isWeb = () => !isCapacitor();
